module.exports = __webpack_public_path__ + "static/media/fly0097.f3e46eb7.webp";